function giftChecker() {
    document.querySelector('input[name="gift_wrap"]').addEventListener('change', function() {
        var gift_msg = document.querySelector('#gift_message')
        var productId = this.dataset.product
        
        if(this.checked) {
            gift_msg.setAttribute('required','')
            this.setAttribute('checked','')
    
            let formData = {
                'items': [{
                 'id': productId,
                 'quantity': 1
                 }]
               };
    
               fetch(window.Shopify.routes.root + 'cart/add.js', {
                 method: 'POST',
                 headers: {
                   'Content-Type': 'application/json'
                 },
                 body: JSON.stringify(formData)
               })
               .then(response => {
                 return response.json();
               })
               .then(response => {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                })
               .catch((error) => {
                 console.error('Error:', error);
                });
    
        } else {
            gift_msg.removeAttribute('required')
            this.removeAttribute('checked')
    
            let formData = {
                    'id': productId,
                    'quantity': 0
                }
    
            fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
            body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
                document.dispatchEvent(new CustomEvent('cart:build'));
            })
              .catch((error) => {
                console.error('Error:', error);
            });
        }
    })
}

document.addEventListener('DOMContentLoaded', function() {
    giftChecker()
})

document.addEventListener('cart:updated', function(evt) {
    giftChecker()
});